import { BadgeSkeleton } from '@/ui/badge/Badge'
import { BaseSkeleton } from '@/ui/skeleton/BaseSkeleton'
import { ButtonSkeleton } from '@/ui/skeleton/ButtonSkeleton.client'
import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'

function ProductRowSkeletons({ count }: { count: number }) {
  return (
    <>
      <BaseSkeleton className="min-h-[32rem] w-full desktop:min-h-20" />
      {Array.from({ length: count }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <BaseSkeleton key={index} className="min-h-[32rem] w-full desktop:min-h-20" />
      ))}
    </>
  )
}

function StocksSkeleton() {
  return (
    <div className="flex flex-col gap-0.5">
      <TextSkeleton className="w-18 desktop:min-w-[17.5rem]" size="xl" leading="normal" />
      <TextSkeleton className="w-18 desktop:min-w-[17.5rem]" size="xl" leading="normal" />
    </div>
  )
}

function PricesSkeleton() {
  return (
    <div className="flex flex-col gap-1">
      <TextSkeleton className="w-18" size="xl" leading="normal" />
      <TextSkeleton className="w-18" size="md" leading="normal" />
    </div>
  )
}

function AddToCartButtonSkeleton() {
  return <ButtonSkeleton isRound size="md" />
}

ProductRowSkeletons.Stocks = StocksSkeleton
ProductRowSkeletons.Prices = PricesSkeleton
ProductRowSkeletons.AddToCartButton = AddToCartButtonSkeleton
ProductRowSkeletons.Badge = BadgeSkeleton

export { ProductRowSkeletons }
